<template>
  <div ref="pdfMain" class="pdf-main">
    <div id="pdf-container"></div>
    <div ref="pdfContainer"></div>
  </div>
</template>

<script>
import { getCosKeyApi } from "@/api/modules/material";
import * as pdfjsLib from "pdfjs-dist";

export default {
  props: {
    pdfUrl: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      cosKey: {}, // cos相关key
      pdfDoc: null, // PDF实例
      totalPages: 0,
      pageCanvases: [],
      watermarkText: sessionStorage.getItem("watermarkText") || "", // 水印
      watermarkOpacity: 0.3, // 水印透明度
    };
  },
  created() {
    this.getCiKey();
  },
  mounted() {
    document.documentElement.classList.add("pdf-preview-mode");
    pdfjsLib.GlobalWorkerOptions.workerSrc =
      "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.11.338/pdf.worker.min.js";
    this.init();
  },
  beforeDestroy() {
    document.documentElement.classList.remove("pdf-preview-mode");
  },
  methods: {
    // 获取coskey
    async getCiKey() {
      const res = await getCosKeyApi();
      if (res.code === 0) {
        this.cosKey = res.data;
      }
    },
    // 初始化PDF
    async init() {
      // 获取authorization
      const cosPath = new URL(this.pdfUrl);
      const signValue = cosPath.searchParams.get("sign");
      cosPath.search = "";
      const baseUrl = cosPath.toString();

      const url = await window.COSDocPreviewSDK.getPreviewUrl({
        objectUrl: baseUrl,
        credentials: {
          secretId: this.cosKey.secretId,
          secretKey: this.cosKey.secretKey,
          authorization: signValue,
        },
        copyable: 0, // 是否可以复制文件内容
        htmlwaterword: window.Base64.encodeUrl(this.watermarkText),
        htmlhorizontal: 100,
        htmlvertical: 150,
      });

      window.COSDocPreviewSDK.config({
        mount: document.querySelector("#pdf-container"),
        url: url,
        mode: "normal",
        pdfOptions: {
          isShowComment: false,
          isInSafeMode: true,
          isShowBottomStatusBar: true,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}
.pdf-main {
  width: 100%;
  height: 100%;
  #pdf-container {
    width: 100%;
    height: 100%;
  }
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
::v-deep .component-icon-btn {
  display: none;
}
</style>

<style lang="less">
html.pdf-preview-mode {
  width: 100vw !important;
  height: 100vh !important;
  overflow: auto !important;
}

html.pdf-preview-mode body {
  position: static !important;
  width: 100% !important;
  height: 100% !important;
  overflow: auto !important;
  top: 0 !important;
  left: 0 !important;
  transform: none !important;
}

html.pdf-preview-mode #app {
  overflow: auto !important;
}
</style>
